import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const Status = styled.div`
  padding: 4px 10px;
  border-radius: 4px;
  background-color: ${({ status }) => {
    const statusColors = {
      WAITING: {
        code: 'color.24',
        color: '#8d9aa4'
      },
      PENDING: {
        code: 'warning.0',
        color: '#F29100'
      },
      CANCELED_BY_BOATER: {
        code: 'error.0',
        color: '#F9503D'
      },
      CANCELED_BY_MARINA: {
        code: 'error.0',
        color: '#F9503D'
      },
      EXPIRED_NO_MARINA_RESPONSE: {
        code: 'error.0',
        color: '#F9503D'
      },
      EXPIRED_NO_BOATER_RESPONSE: {
        code: 'error.0',
        color: '#F9503D'
      },
      APPROVED: {
        code: 'success.0',
        color: '#00BB5D'
      },
      APPROVED_PAID: {
        code: 'success.0',
        color: '#00BB5D'
      },
      INSTANT_BOOK: {
        code: 'success.0',
        color: '#00BB5D'
      },
      WAITING_LIST: {
        code: 'color.24',
        color: '#8d9aa4'
      }
    };
    const { code, color } = statusColors[status] || statusColors['WAITING'];
    return themeGet(code, color);
  }};
  color: ${themeGet('color.1', '#ffffff')};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: right;
  text-transform: uppercase;
  border: 1px solid #E0E0E0;
`;

export const Source = styled.div`
  position: absolute;
  top: 100%;
  color: ${themeGet('text.1', '#909090')};
  font-weight: bold;
  font-size: 11px;
  white-space: nowrap;
`;

export default Status;
